import { PlusOutlined } from "@ant-design/icons";
import { Image, Modal, Upload } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import { useEffect, useState } from "react";
import { getToken } from "utils/auth";
import { $url } from "utils/url";

interface MultiImageUploadProps {
  uploadUrl?: string;
  onUploadOk?: (fileList: Array<string>) => void;
  fileListProp: UploadFile<any>[];
  onUploadOk2?: (fileList: UploadFile<any>[]) => void;
  multiple?: boolean;
}

export const MultiImageUpload = ({
  uploadUrl = import.meta.env.VITE_API_URL + "/v1/admin/staff/upload",
  fileListProp,
  onUploadOk,
  onUploadOk2,
  multiple = false,
}: MultiImageUploadProps) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState<UploadFile<any>[]>();

  const handleChange = ({ fileList }: { fileList: UploadFile<any>[] }) => {
    setFileList(fileList);
    console.log("filelist", fileList);
    const filePathList = fileList.map((file) => {
      return $url(file.response?.data?.path || file.url);
    });

    onUploadOk?.(filePathList);
    onUploadOk2?.(fileList);
  };

  useEffect(() => {
    setFileList(() => fileListProp.map((e) => ({ ...e })));
  }, [fileListProp]);

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handlePreview = (e: UploadFile<any>) => {
    console.log("e", e);
    const imageUrl = e.url || import.meta.env.VITE_API_URL + e.response.data.path;
    setPreviewImage(imageUrl);
    setPreviewVisible(true);
  };

  return (
    <>
      <Upload
        headers={{ token: getToken() || "" }}
        action={uploadUrl}
        listType="picture-card"
        fileList={fileList}
        onPreview={(file) => handlePreview(file)}
        onChange={handleChange}
        multiple={multiple}
      >
        {fileList && fileList.length >= 8 ? null : uploadButton}
      </Upload>

      <Image
        style={{ display: "none" }}
        src={previewImage}
        preview={{
          visible: previewVisible,
          src: previewImage,
          onVisibleChange: (visible) => setPreviewVisible(visible),
        }}
      />
    </>
  );
};
